/**
 * Converte um índice 0-based na letra do grupo (0 → A, 25 → Z, 26 → AA).
 */
export const groupLetter = (index: number): string => {
  let n = index;
  let letter = '';

  do {
    letter = String.fromCharCode(65 + (n % 26)) + letter;
    n = Math.floor(n / 26) - 1;
  } while (n >= 0);

  return letter;
};
